module.exports = __webpack_public_path__ + "img/202501_03.9e2c7a1f.jpg";